import React from "react";
import {
  Button,
  Card,
  CardContent,
  CircularProgress,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SessionStatusChip from "./SessionStatusChip";

function fmt(value) {
  if (value === undefined || value === null || value === "") return "—";
  return String(value);
}

function fmtDateTime(value) {
  if (!value) return "—";
  return new Date(value).toLocaleString();
}

export default function DripSessionListTable({ rows, loading, error }) {
  const navigate = useNavigate();

  return (
    <Card elevation={0} sx={{ borderRadius: 4, border: "1px solid #e2e8f0" }}>
      <CardContent sx={{ p: 0 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: 2.5 }}>
          <Typography variant="h6" sx={{ fontWeight: 800 }}>
            Drip Session List
          </Typography>
        </Stack>

        {loading ? (
          <Stack alignItems="center" justifyContent="center" sx={{ py: 8 }}>
            <CircularProgress />
          </Stack>
        ) : error ? (
          <Typography sx={{ color: "#b42318", px: 2.5, pb: 2.5 }}>{error}</Typography>
        ) : rows.length === 0 ? (
          <Typography sx={{ color: "#64748b", px: 2.5, pb: 2.5 }}>
            No session records found.
          </Typography>
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 800 }}>Session ID</TableCell>
                <TableCell sx={{ fontWeight: 800 }}>Patient Name</TableCell>
                <TableCell sx={{ fontWeight: 800 }}>Patient UID</TableCell>
                <TableCell sx={{ fontWeight: 800 }}>Fluid Serial Number</TableCell>
                <TableCell sx={{ fontWeight: 800 }}>Start Date Time</TableCell>
                <TableCell sx={{ fontWeight: 800 }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 800 }}>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row) => {
                const sessionId = row.session_id || row.drip_session_id || row.id;

                return (
                  <TableRow key={sessionId} hover>
                    <TableCell>{fmt(sessionId)}</TableCell>
                    <TableCell>{fmt(row.patient_name)}</TableCell>
                    <TableCell>{fmt(row.patient_uid)}</TableCell>
                    <TableCell>{fmt(row.fluid_serial_number)}</TableCell>
                    <TableCell>{fmtDateTime(row.start_at)}</TableCell>
                    <TableCell>
                      <SessionStatusChip status={row.status} />
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => navigate(`/monitoring/drip-sessions/${sessionId}`)}
                      >
                        View Details
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}